module.exports = __webpack_public_path__ + "media/images/default/lp_top_capture_file1-2f2265db52b64de0736340f869f44e97.svg";